export default "__VITE_ASSET__cf326c6c__"